// extracted by mini-css-extract-plugin
export default {"cls1":"Y1etSIf8jWSCgzZ8N4ug","cls2":"p5OOZEP33JytcHx09AGf Y1etSIf8jWSCgzZ8N4ug","isTabletUp":"KaR3sYGthcCg3M6CAZS9"};